import React, { memo } from "react";
import KTSearchKeywordsDropdown from "../../../../../../dropdown/search-keywords-dropdown";

const KTAppHeaderMobileSearchInput = memo(() => {
  return <KTSearchKeywordsDropdown />;
});

export default KTAppHeaderMobileSearchInput;
